import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar";

export const Separation: React.FC = () => {
  return (
    <>
      <Navbar title="Separar" />
      <Outlet />
    </>
  );
};
